import { IAppStateDto } from "../Models/IAppStateDto";
import * as actionTypes from "./actionTypes";
import { DispatchType, GlobalAppStateAction } from "./GlobalAppState";

export function setAppState(appState: IAppStateDto) {
  const action: GlobalAppStateAction = {
    type: actionTypes.SET_APPSTATE,
    appState,
  };

  return (dispatch: DispatchType) => {
    dispatch(action);
  };
}
